import { useMemo, useState } from 'react';
import { useLocation } from 'react-router';

import useShouldShowWhatsappVerification from '../../../common/hooks/useShouldShowWhatsappVerification';
import { ROUTES } from '../../../common/routes';
import useGetAlternativeHeaderContent from './useGetAlternativeHeaderContent';

type AlternativeHeaderState =
  | {
      showAlertNativeHeader: true;
      alternativeHeaderContent: JSX.Element | null;
    }
  | {
      showAlertNativeHeader: false;
      alternativeHeaderContent: null;
    };

export default function useShowAlternativeHeader() {
  const { pathname } = useLocation();
  const [
    { showAlertNativeHeader, alternativeHeaderContent },
    setShowAlternativeHeader,
  ] = useState<AlternativeHeaderState>({
    showAlertNativeHeader: false,
    alternativeHeaderContent: null,
  });
  const alternativeHeaderContentBasedOnPathName =
    useGetAlternativeHeaderContent();
  const shouldShowWhatsappVerification = useShouldShowWhatsappVerification();

  const pathNameWithoutTrailingSlash = useMemo(() => {
    if (pathname === '/') {
      return pathname;
    }
    return pathname.replace(/\/+$/, '');
  }, [pathname]);

  const contentComponent = shouldShowWhatsappVerification
    ? alternativeHeaderContentBasedOnPathName[`/${ROUTES.onboarding}`]
    : alternativeHeaderContentBasedOnPathName[pathNameWithoutTrailingSlash];

  const showHeader =
    shouldShowWhatsappVerification ||
    Object.keys(alternativeHeaderContentBasedOnPathName).includes(
      pathNameWithoutTrailingSlash
    );

  const routesWithNoNavigation = [
    ROUTES.companyReportStatus,
    ROUTES.onboarding,
  ];

  return {
    showAlternativeHeader: showAlertNativeHeader || showHeader,
    alternativeHeaderContent:
      alternativeHeaderContent || contentComponent?.navbarContent,
    alternativeSidebarContent: contentComponent?.sidebarContent,
    alternativeMobileContent: contentComponent?.mobileContent,
    preventNavigation: routesWithNoNavigation.some(route =>
      pathname.includes(route)
    ),
    setShowAlternativeHeader,
  } as const;
}
